export const mkGuard = <T>() => {
    return (value: T) => guard(value);
};

export default function guard<T>(value: T): T {
    return value;
}
